const CONNECTION_ERROR =
  'Não foi possível conectar à API. Verifique se o serviço está em execução e tente novamente.';

export function getCrudErrors(error: unknown): string[] {
  return [getCrudErrorMessage(error)];
}

export function getCrudErrorMessage(error: unknown, fallback?: string): string {
  if (isConnectionFailure(error)) {
    return CONNECTION_ERROR;
  }

  const message = readApiMessage(error);

  if (message) {
    return message;
  }

  if (fallback === undefined && error instanceof Error && error.message.trim()) {
    return error.message.trim();
  }

  return fallback ?? 'Erro desconhecido';
}

function readApiMessage(error: unknown): string {
  const record = asRecord(error);
  const body = asRecord(record?.['error']);
  const apiMessage = body?.['message'];

  if (typeof apiMessage === 'string' && apiMessage.trim()) {
    return apiMessage.trim();
  }

  if (error instanceof Error) {
    return '';
  }

  const directMessage = record?.['message'];

  if (typeof directMessage === 'string' && directMessage.trim()) {
    return directMessage.trim();
  }

  return '';
}

function isConnectionFailure(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const status = asRecord(error)?.['status'];

  return status === 0;
}

function asRecord(value: unknown): Record<string, unknown> | undefined {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return undefined;
  }

  return value as Record<string, unknown>;
}
